import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { BasketScrappageDetailsStyled } from '../BasketScrappageDetailsStyled';
import { rem } from 'polished';

export const BasketScrappageDetailsAC = styled(BasketScrappageDetailsStyled)`
    .summary {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .description {
        color: ${({ theme }) => theme.colors.grey5};

        .linkText {
            padding-bottom: unset;
        }
    }
`;
